// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3CDC7","checkboxCol":"Table_checkboxCol__2cEpd","emailCol":"Table_emailCol__25W15","actionCol":"Table_actionCol__1RSoK"};